import React from 'react';
import styles from './CardDetails.module.css';


const QuestionnaireDetails = ( { questionnaire } ) => {
    const questions = questionnaire.questions;
    const answers = questionnaire.answers ?? [];
    
    return (
        <div className={styles.DetailsContainer}>
            <div className="d-flex justify-content-between align-items-center" style={{width:"100%"}}>
                        <span>{`Total ${questions.length} questions`}</span>
                        <span>{`${questionnaire?.score !== undefined ? `Score: ${questionnaire.score}/${questionnaire.possibleScore}` : ""}`}</span>
                    </div>
            {questions.map((question, index) => {
                return (
                    <div key={index} className={styles.Question} style={{borderBottom: index !== questions.length - 1 ? "0.5px solid #B9B9B9" : "none"}}>
                        <span>{`${index+1}. ${question.questionText} (${question.answerType})`}</span>
                        {["Multi Select", "Single Select"].includes(question.answerType) ? (
                            <span>
                                {question.possibleAnswers.map((answer, i) => {
                                    let selected = false;
                                    const ans = answers[index];
                                    if (ans) {
                                        if (Array.isArray(ans.selectedAnswer)) {
                                            selected = ans.selectedAnswer.includes(answer.answerText);
                                        } else {
                                            selected = ans.selectedAnswer === answer.answerText;
                                        }
                                    }
                                    return (
                                        <div key={i} style={{ display: "block" }}>
                                            {selected ? <b>{answer.answerText}</b> : answer.answerText}
                                        </div>
                                    );
                                })}
                            </span>
                        ) : 
                            <span><b>{answers[index]?.selectedAnswer}</b></span>
                        }
                        {answers.length > 0 && 
                            <span>{`Score: ${answers[index]?.score}`}</span>
                        }
                    </div>
                )
            })}
        </div>
    )
}
export default QuestionnaireDetails;